import { jsx as _jsx } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useContext } from 'react';
import { CaptchaAction } from '../../../subcomponents/captcha/types/action';
import { CaptchaField } from '../../../subcomponents/form/field/captcha/captcha-field';
import { CurrentPasswordField } from '../../../subcomponents/form/field/current-password/current-password-field';
import { PasswordField } from '../../../subcomponents/form/field/password/password-field';
import { getFieldClassName, getFieldId } from '../../../subcomponents/form/field/utils/field-attribute-utils';
import { InvalidFieldNameError } from '../../../types/invalid-field-name-error';
import { withComponentWrapper } from '../../../utils/with-component-wrapper';
import { UpdateMemberPasswordFormContextInstance } from '../update-password-form/types/context';
import { UpdateMemberPasswordFormFieldName } from './types/name';
import { defaultUpdateMemberPasswordFormFieldPropsProvider, updateMemberPasswordFormFieldPropsValidator } from './types/props';
const b = bemClassBuilder('v-update-member-password-form-field');
const UpdateMemberPasswordFormField = observer(props => {
    const { onChange, validationConfig, validator, formData, validationResult, disabled } = useContext(UpdateMemberPasswordFormContextInstance);
    const getCommonFieldProps = (key) => ({
        id: getFieldId(b, key),
        name: key,
        className: getFieldClassName(b, key),
        error: validationResult.validationErrors[key],
        disabled
    });
    switch (props.name) {
        case UpdateMemberPasswordFormFieldName.Password: {
            const key = 'password';
            return (_jsx(PasswordField, Object.assign({}, getCommonFieldProps(key), { value: formData[key], validationConfig: validationConfig[key], validate: newValue => validator.validateField(key, newValue), onChangeValue: newValue => onChange(key, newValue), displayText: props.displayText })));
        }
        case UpdateMemberPasswordFormFieldName.CurrentPassword: {
            const key = 'currentPassword';
            return (_jsx(CurrentPasswordField, Object.assign({}, getCommonFieldProps(key), { value: formData[key], validationConfig: validationConfig[key], validate: newValue => validator.validateField(key, newValue), onChangeValue: newValue => onChange(key, newValue), displayText: props.displayText })));
        }
        case UpdateMemberPasswordFormFieldName.Captcha: {
            const key = 'captcha';
            return (_jsx(CaptchaField, Object.assign({}, getCommonFieldProps(key), { validationConfig: validationConfig[key], validate: newValue => validator.validateField(key, newValue), onChangeValue: newValue => onChange(key, newValue), displayText: props.displayText, action: CaptchaAction.UpdateMemberPassword })));
        }
        default:
            throw new InvalidFieldNameError('UpdateMemberPasswordFormField', props.name);
    }
});
UpdateMemberPasswordFormField.displayName = 'UpdateMemberPasswordFormField';
export const UpdateMemberPasswordFormFieldComponent = withComponentWrapper(UpdateMemberPasswordFormField, defaultUpdateMemberPasswordFormFieldPropsProvider, updateMemberPasswordFormFieldPropsValidator);
//# sourceMappingURL=update-member-password-form-field.js.map